module.exports = __webpack_public_path__ + "static/img/logo1.fed4a19.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo1.png
// module id = LJ2z
// module chunks = 1